import { render, staticRenderFns } from "./menu-service.vue?vue&type=template&id=45f7b7c7&"
import script from "./menu-service.vue?vue&type=script&lang=js&"
export * from "./menu-service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports